import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { renderRoutes } from 'react-router-config';
import { Redirect } from 'react-router-dom';

import WebGalleryHeaderContainer from '../containers/WebGalleryHeaderContainer';
import { MeQuery } from '../../../graphql/queries/account';
import { AlbumPhotoGroupForWebGallery } from '../graphql/queries/album-photo-group';
import WebGalleryAlbumNavigationlessHeader from './WebGalleryAlbumView/components/WebGalleryAlbumNavigationlessHeader';

const WebGalleryPhotoGroupView = ({ loading, album, photoGroup, route }) => {
  if (loading || !album || !photoGroup) {
    return (
      <div className="d-block text-center mt-6">
        <span className="spinner" />
      </div>
    );
  }

  if (!album.is_web_gallery) {
    return <Redirect to="/not-found" />;
  }

  if (!loading && !album && !photoGroup) {
    return <Redirect to="/not-found" />;
  }

  return (
    <Fragment>
      <Helmet>
        <title>Album Photos &ndash; Waldo</title>
      </Helmet>

      <WebGalleryHeaderContainer />

      <div className="flex-auto">
        <WebGalleryAlbumNavigationlessHeader
          album={album}
          photoGroup={photoGroup}
        />
        {renderRoutes(route.routes)}
      </div>
    </Fragment>
  );
};

const withPhotoGroup = graphql(AlbumPhotoGroupForWebGallery, {
  options: ({ match }) => ({
    variables: {
      id: match.params.photoGroupId,
      for_web_gallery: true,
    },
  }),
  skip: ({ match }) => !match.params.photoGroupId,
  props: ({ data: { loading, albumPhotoGroup } }) => ({
    loading,
    photoGroup: albumPhotoGroup,
    album: albumPhotoGroup && albumPhotoGroup.album,
  }),
});

const withUserData = graphql(MeQuery, {
  props: ({ data }) => ({
    user: data.me,
  }),
  skip: ({ authenticated }) => !authenticated,
});

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(
  connect(mapStateToProps),
  withPhotoGroup,
  withUserData,
)(WebGalleryPhotoGroupView);
